module.exports = __webpack_public_path__ + "static/media/moderator-default.2ee656da.gif";